export default __webpack_public_path__ + "static/media/video-views-example.047dd374.png";